import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopSoftware = dynamic(() => import("../components/software/DesktopSoftware"), {
  loading: () => <Loading />
})

const MobileSoftware = dynamic(() => import("../components/software/MobileSoftware"), {
  loading: () => <Loading />
})

const software = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>POS Software Compatible With 50+ Advanced Business Softwares</title>
        <meta name="description" content="Discover POS software compatible with over 50 advanced business applications. Streamline your operations with our versatile and integrated solutions." />
        <link rel="canonical" href="https://queuebuster.co/pos-software-partners" />
        <link rel="alternate" href="https://queuebuster.co/pos-software-partners" hrefLang="en-us" />
        <meta property="og:title" content="POS Software Compatible With 50+ Advanced Business Softwares" />
        <meta property="og:description" content="Discover POS software compatible with over 50 advanced business applications. Streamline your operations with our versatile and integrated solutions." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/software.jpg" />
        <meta property="og:url" content="https://queuebuster.co/pos-software-partners" />

      </Head>
      {
        mobileView ? <MobileSoftware /> : <DesktopSoftware />
      }
    </>
  )
}

export default software